import type { AnyObject } from 'types/AnyObject';

export const sortItemsFilterWithNullable = (array?: any[] | null, enumItems?: AnyObject) => {
    if (!array) {
        return null;
    }

    let nullableItem;

    const items = array.map(({ value }: { value: string }) => {
        if (!value) {
            nullableItem = {
                name: '<Нет значения>',
                value,
            };
        }

        return {
            name: enumItems ? enumItems[value] : value,
            value,
        };
    });

    if (!nullableItem) {
        return items;
    }

    return [...items.filter(({ value }: { value: string }) => value), nullableItem];
};
